// Layout.tsx
import { Box} from "@chakra-ui/react";
import NavBar from './NavBar'; // Your Navbar component
import Footer from './Footer'; // Your Footer component


interface PublicLayoutProps {
  children: React.ReactNode;
}



const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const onLogout = () => {};
  return (
    
    <Box>
      {/* <NavBar isAuthenticated={false} onLogout={onLogout} userInitials={null}  /> */}
      <Box as="main" minH="80vh"   mt="72px">
        {children} {/* Page content goes here */}
      </Box>
      <Footer />
    </Box>
    
  );
};

export default PublicLayout;
